import React, { useEffect, useState } from "react";
import TopNavbar from "../../CommonComponent/topNavbar/TopNavbar";
import Sidebar from "../../CommonComponent/sidebar/Sidebar";
import { Button, Col, Row } from "react-bootstrap";
import DataTable from "react-data-table-component";
import * as icons from "react-bootstrap-icons";
import { UserAll, UserAllData } from "../../redux/auth-reducer/auth-service";
import { Footer } from "../../Footer";
import dayjs from "dayjs";
import { CancelPlayerDeletionModal, deletionColumn } from "./PlayerDeletion";
export const User = () => {
  const [data, setData] = useState(false);
  const [sidebar, setSidebar] = useState(false);
  const [apiData, setApiData] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [count, setCount] = useState(0);
  const [totalRows, setTotalRows] = useState(1);
  const [currentPage, setCurrentPage] = useState(1); // Initialize current page state
  const [perPage, setPerPage] = useState(10);
  // #234: the player whose deletion request the Web Admin is about to cancel.
  const [cancelDeletionOf, setCancelDeletionOf] = useState(null);
  const pageOptions = [10, 20, 30, 50];
  function sidebarfun() {
    setSidebar(!sidebar);
  }
  // useEffect(() => {
  //     dataApi()
  // }, [count]);
  // const dataApi = async (event) => {
  //     await UserAll().then((res) => {
  //         setApiData(res?.data?.data.dataList)
  //     })
  // }

  const dataApi = async (data) => {
    try {
      const response = await UserAllData(data); // Call your API function
      if (response?.data) {
        setApiData(response.data.data.dataList || []); // Set the item list
        setTotalRows(response.data.data.totalPageSize || 0); // Set the total number of rows
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  // Effect to fetch data when current page changes
  useEffect(() => {
    const data = {
      SearchTerm: 'Active',
      SortColumn: 'status',
      PageNumber: currentPage,
      PageSize: perPage,
      SortOrder: true,
    };
    dataApi(data); // Fetch data when currentPage changes
  }, [currentPage, count]); // Dependency on currentPage

  const handlePerPageChange = (event) => {
    const newPerPage = Number(event.target.value);

    const data = {
       SearchTerm: 'Active',
      SortColumn: 'status',
      PageNumber: currentPage,
      PageSize: newPerPage,
      SortOrder: false,
    };
    dataApi(data);
    setPerPage(newPerPage); // Update items per page
    setCurrentPage(1); // Reset to first page when items per page changes
  };
  // Handle page change
  const handleNextPage = () => {
    if (currentPage < Math.ceil(totalRows)) {
      setCurrentPage((prevPage) => prevPage + 1); // Go to next page
    }
  };

  const handlePreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage((prevPage) => prevPage - 1); // Go to previous page
    }
  };

  function convertUTCToLocalTime(utcDateString) {
    const date = new Date(utcDateString);
    return date.toString(); // Or use date.toLocaleString() for better format
  }
  const columns = [
    {
      name: "id",
      selector: (row, index) => index + 1,

      width: "80px",
    },
    {
      name: "Name",
      selector: (row) => row?.firstName + " " + row?.lastName,
      sortable: true,
    },

    {
      name: "Email",
      selector: (row) => row?.emailId,
      sortable: true,
    },

    {
      name: <strong>Join Date & Time</strong>,
      selector: (row) => {
        // Ensure row?.endDate is defined
        if (!row?.createdDate) return <p>Invalid date</p>;
        return (
          <p>{dayjs(row?.createdDate + "Z").format("MM/DD/YYYY hh:mm:ss A")}</p>
        );
      },
    },
      {
      name: "Status",
      // selector: (row) => row?.status,
      selector: (row) => ( 
       <>
          {row?.status === "Active" ? (
            <button className="tablebtn active-status">Active</button>
          ) : (
            <button className="tablebtn bg-dang">Inactive</button>
          )}
        </>
        ),
    },
    deletionColumn(setCancelDeletionOf),
  ];
  const handleSearch = (e) => {
    setSearchText(e.target.value);
  };

  const filteredData = searchText
    ? apiData.filter((item) => {
        return (
          item?.lastName?.toLowerCase().includes(searchText?.toLowerCase()) ||
          item?.firstName?.toLowerCase().includes(searchText?.toLowerCase())
        );
      })
    : apiData;
  const clearSearch = () => {
    setSearchText("");
  };
  return (
    <>
      <TopNavbar sidebarfun={sidebarfun} />
      <CancelPlayerDeletionModal
        player={cancelDeletionOf}
        onClose={() => setCancelDeletionOf(null)}
        onDone={() => {
          setCancelDeletionOf(null);
          setCount((c) => c + 1);
        }}
      />

      <div className="dasboard-group">
        <Sidebar data={sidebar} />
        <div
          className={
            sidebar ? "dashboard-content full-contnet" : "dashboard-content"
          }
        >
          <Row>
            <Col md="10">
              <h1 className="heading-dash">Players List</h1>
            </Col>
            <Col md="2 text-right mb-3"></Col>
          </Row>

          <div className="table-responsive">
            <div className="group_data_table list-player">
              <div className="search-input d-flex align-items-center">
                <input
                  type="text"
                  className="form-control mb-3 mt-3"
                  placeholder="Search..."
                  value={searchText}
                  onChange={handleSearch}
                />
                {searchText && (
                  <button className="btn btn-clear" onClick={clearSearch}>
                    <span>&times;</span> {/* This represents the close icon */}
                  </button>
                )}
              </div>
              {/* <DataTable
                                title="Player List"
                                columns={columns}
                                data={filteredData}
                                pagination
                                paginationPerPage={10}
                                paginationRowsPerPageOptions={[5, 10, 15]}
                                paginationTotalRows={filteredData?.length}
                            /> */}
              <div>
                <DataTable
                  title="Player List"
                  columns={columns}
                  data={filteredData}
                  paginationPerPage={perPage}
                  paginationTotalRows={totalRows * 10}
                  paginationDefaultPage={currentPage}
                  onChangePage={setCurrentPage}
                />
                {totalRows >= 1 && (
                  <Row>
                    <Col md={12} className="text-right">
                      <div className="pagination-controls">
                        <>
                          <label>Rows page: </label>{" "}
                          <select
                            id="itemsPerPage"
                            value={perPage}
                            onChange={handlePerPageChange}
                          >
                            {pageOptions.map((option) => (
                              <option key={option} value={option}>
                                {option}
                              </option>
                            ))}
                          </select>
                        </>

                        <Button
                          onClick={handlePreviousPage}
                          disabled={currentPage === 1}
                        >
                          <icons.ArrowLeft></icons.ArrowLeft>
                        </Button>
                        <span>
                          {" "}
                          {currentPage} of {totalRows}{" "}
                        </span>
                        <Button
                          onClick={handleNextPage}
                          disabled={currentPage >= Math.ceil(totalRows)}
                        >
                          <icons.ArrowRight></icons.ArrowRight>
                        </Button>
                      </div>
                    </Col>
                  </Row>
                )}
              </div>
            </div>
          </div>
        </div>
        <div className={data ? "footer" : "footer-content"}>
          <Footer />
        </div>
      </div>
    </>
  );
};
